import { AbstractControl, ValidatorFn } from '@angular/forms';
import { atLeastOneConsentValidator } from './consent.validator';

export function bookingTypeScopedValidator(): ValidatorFn {
  return (control: AbstractControl) => {
    const type = control.get('bookingType')?.value;

    if (type !== 'newBooking') {
      return null;
    }

    const newBookingGroup = control.get('newBooking');
    if (!newBookingGroup) return null;

    return atLeastOneConsentValidator()(newBookingGroup as any);
  };
}
